module.exports = __webpack_public_path__ + "static/media/M91ws.cb7407ed.pdf";